import React from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'

import responsive from 'common/utils/responsive'
import style from './BookingsNavBar.less'
import R2rLogo from 'styles/icons/r2r-logo.svg'
import UserPreferencesDropDownContainer from 'tickets/containers/UserPreferencesDropDownContainer'
import { helpFaqMsg } from './BookingsNavBar.messages'

const BOOKING_NAV_BAR_STEPS = {
  TICKETS: 'TICKETS',
  PASSENGERS: 'PASSENGERS',
  PAYMENT: 'PAYMENT',
}

// eslint-disable-next-line no-unused-vars
const BookingsNavBar = ({ step, showCurrency, helpUrl }) => (
  <div className={style.topWrapper}>
    <div className={style.topInnerWrapper}>
      <a href="/" className={style.headerLogo}>
        <span className={style.headerLogoLarge}>
          <svg viewBox={R2rLogo.viewBox}>
            <title>Rome2Rio Logo</title>
            <use xlinkHref={`#${R2rLogo.id}`} />
          </svg>
        </span>
      </a>

      <div className={style.actions}>
        {showCurrency &&
          <UserPreferencesDropDownContainer />
        }
        {helpUrl &&
          <MediaQuery minWidth={responsive.MEDIA_QUERY_TABLET}>
            <a href={helpUrl} target="_blank" >{helpFaqMsg}</a>
          </MediaQuery>
        }
      </div>
    </div>
  </div>
)

BookingsNavBar.propTypes = {
  step: PropTypes.oneOf(Object.values(BOOKING_NAV_BAR_STEPS)).isRequired,
  showCurrency: PropTypes.bool,
  helpUrl: PropTypes.string,
}

BookingsNavBar.defaultProps = {
  showCurrency: true,
  helpUrl: null,
}

export { BOOKING_NAV_BAR_STEPS }
export default BookingsNavBar
